var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "AIDrawer" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "70%",
            top: "5vh",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _c(
                "el-row",
                { staticClass: "wh100", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "h100",
                      staticStyle: { "border-right": "1px solid #e4e4e4" },
                      attrs: { span: 12 },
                    },
                    [
                      _c("div", { staticClass: "h" }, [_vm._v("设备信息")]),
                      _c(
                        "el-descriptions",
                        {
                          staticClass: "margin-top",
                          attrs: { column: 1, border: "" },
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v(" 设备编号 "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.devInfo.DeviceCode ||
                                      _vm.row.DeviceItemCode ||
                                      ""
                                  ) +
                                  " "
                              ),
                            ],
                            2
                          ),
                          _c(
                            "el-descriptions-item",
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v(" 设备名称 "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.devInfo.device_name ||
                                      _vm.row.DeviceItemName ||
                                      ""
                                  ) +
                                  " "
                              ),
                            ],
                            2
                          ),
                          _c(
                            "el-descriptions-item",
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v(" 安装位置 "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.devInfo.InstallationAreaName || ""
                                  ) +
                                  " "
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("描述说明"),
                          ]),
                          _c("el-input", {
                            staticStyle: { "border-radius": "20px" },
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入内容",
                              rows: "20",
                              resize: "none",
                            },
                            model: {
                              value: _vm.textarea,
                              callback: function ($$v) {
                                _vm.textarea = $$v
                              },
                              expression: "textarea",
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "20px 0",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-s-tools",
                                    loading: _vm.loading,
                                  },
                                  on: { click: _vm.AIop },
                                },
                                [_vm._v("生成")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticClass: "h100 AIlo",
                      attrs: {
                        span: 12,
                        "element-loading-text": "AI拼命生成中...",
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(0, 0, 0, 0.8)",
                        "element-loading-customClass": "AIlo",
                      },
                    },
                    [
                      _c("div", { staticClass: "h" }, [_vm._v("建议描述")]),
                      _vm.value !== ""
                        ? _c("quill-editor", {
                            ref: "myQuillEditor",
                            staticStyle: {
                              height: "calc(100% - 120px)",
                              "padding-bottom": "70px",
                            },
                            attrs: { options: _vm.editorOption },
                            model: {
                              value: _vm.value,
                              callback: function ($$v) {
                                _vm.value = $$v
                              },
                              expression: "value",
                            },
                          })
                        : _vm._e(),
                      _vm.value === ""
                        ? _c("el-empty", {
                            attrs: {
                              image: _vm.shengcheng,
                              description:
                                "请在左侧输入您的描述说明，\nAI将在此处显示建议描述。",
                            },
                          })
                        : _vm._e(),
                      _vm.value !== ""
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                height: "40px",
                                "text-align": "right",
                                "margin-top": "20px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-circle-check",
                                    loading: _vm.loading,
                                  },
                                  on: { click: _vm.AIYes },
                                },
                                [_vm._v("应用")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }